// :cow: Cosmose CONFIDENTIAL :iso:
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { of } from 'rxjs';
import {
  dashboardLocationPreferencesRequested,
  dashboardLocationPreferencesRequestFailed,
  dashboardLocationPreferencesRequestSucceeded,
} from './dashboard-location-preferences.actions';
import { DashboardLocationPreferencesService } from '../services/dashboard-location-preferences.service';
import { SnackbarService } from '@coa/app/libs/services/snackbar.service';

@Injectable()
export class DashboardLocationPreferencesEffects {

  dashboardSummaryRequested$ = createEffect(() =>
    this.actions$.pipe(
      ofType(dashboardLocationPreferencesRequested),
      mergeMap((action) => this.dashboardSummaryService.getLocationPreferences(action.clientId, action.timePeriod)
        .pipe(
          map((locationPreferencesResponse) => dashboardLocationPreferencesRequestSucceeded({locationPreferencesResponse})),
          catchError(() => of(dashboardLocationPreferencesRequestFailed())),
        )),
    ), {dispatch: true},
  );

  constructor(
    private actions$: Actions,
    private store$: Store,
    private snackbarService: SnackbarService,
    private dashboardSummaryService: DashboardLocationPreferencesService,
  ) {
  }
}
